var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillAnalysisIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7207 3.82027H23.4847V1.34827H21.0127V3.82027H8.65266V1.34827H6.18066V3.82027H4.94466C3.58506 3.82027 2.47266 4.93267 2.47266 6.29227V26.0683C2.47266 27.4279 3.58506 28.5403 4.94466 28.5403H24.7207C26.0803 28.5403 27.1927 27.4279 27.1927 26.0683V6.29227C27.1927 4.93267 26.0803 3.82027 24.7207 3.82027ZM24.7207 26.0683H4.94466V12.4723H24.7207V26.0683ZM24.7207 10.0003H4.94466V6.29227H24.7207V10.0003Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillAnalysisIconDark);
export default __webpack_public_path__ + "static/media/SkillAnalysisIconDark.3c171b2b88875c4e1be0252a9ebdfbcf.svg";
export { ForwardRef as ReactComponent };